import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/feature/Breadcrumb';
import ScrollToTop from '@/components/feature/ScrollToTop';

export default function AboutPage() {
  const pageTitle = '关于我们 - 耽美漫画网';
  const pageDesc = '耽美漫画网致力于提供最优质的免费耽美漫画在线阅读服务，汇聚海量免费BL漫画资源，每日更新，高清流畅，零成本追漫。了解耽美漫画网的品牌故事、用户口碑与联系方式。';

  return (
    <>
      <ScrollToTop />
      <Navbar />
      <main className="min-h-screen pt-20 pb-12 bg-background-50">
        <div className="max-w-4xl mx-auto px-4 md:px-6">
          <Breadcrumb
            items={[
              { label: '首页', href: '/' },
              { label: '关于我们' },
            ]}
          />

          <header className="mt-8 mb-10">
            <h1 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">关于我们</h1>
            <p className="text-sm text-foreground-500 mt-2">了解耽美漫画网的品牌故事与发展历程</p>
          </header>

          <section className="mb-12">
            <h2 className="text-xl font-heading font-bold text-foreground-900 mb-4">品牌介绍</h2>
            <div className="bg-background-100 rounded-lg p-6 md:p-8">
              <p className="text-sm text-foreground-700 leading-relaxed mb-4">
                耽美漫画网成立于2020年，是国内领先的<strong>免费耽美漫画</strong>在线阅读平台。我们致力于为全球耽美爱好者提供最全面、最优质的<strong>免费BL漫画</strong>资源。平台汇聚了校园、古风、奇幻、现代、悬疑等各类题材的耽美漫画，每日更新，确保读者可以第一时间阅读到最新内容。
              </p>
              <p className="text-sm text-foreground-700 leading-relaxed mb-4">
                作为一个纯粹的漫画阅读平台，耽美漫画网始终坚持"免费、高清、流畅"的服务理念。我们拥有专业的漫画编辑团队，精选国内外优秀创作者的耽美作品，为读者打造极致的<strong>耽美漫画免费阅读</strong>体验。
              </p>
              <p className="text-sm text-foreground-700 leading-relaxed">
                无论您是资深耽美爱好者，还是刚刚接触BL漫画的新读者，耽美漫画网都能满足您的阅读需求。我们提供便捷的搜索功能、清晰的分类导航和个性化的推荐系统，让您轻松发现感兴趣的<strong>免费看耽美</strong>资源。
              </p>
            </div>
          </section>

          <section className="mb-12">
            <h2 className="text-xl font-heading font-bold text-foreground-900 mb-4">用户口碑</h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              {[
                {
                  name: '小星星',
                  text: '耽美漫画网是我每天必刷的网站！漫画更新超快，画质也很清晰，而且完全免费，真的太良心了。最喜欢古风类的漫画，推荐《凤求凰》！',
                  rating: 5,
                },
                {
                  name: '风间琉璃',
                  text: '作为多年的耽美爱好者，试过很多漫画网站，耽美漫画网是体验最好的一个。分类清晰，搜索方便，漫画种类也很全。强烈推荐！',
                  rating: 5,
                },
                {
                  name: '月光下的猫',
                  text: '从朋友那里知道的耽美漫画网，一用就爱上了。校园题材的漫画特别好看，而且每天都有更新，追漫党狂喜！希望能一直做下去。',
                  rating: 5,
                },
                {
                  name: '北冥有鱼',
                  text: '非常棒的免费BL漫画网站！界面简洁，阅读流畅，没有烦人的广告弹窗。悬疑类的漫画质量很高，是我目前最常用的漫画阅读平台。',
                  rating: 4,
                },
              ].map((review, idx) => (
                <div key={idx} className="bg-background-100 rounded-lg p-5">
                  <div className="flex items-center gap-2 mb-2">
                    {Array.from({ length: 5 }).map((_, i) => (
                      <i
                        key={i}
                        className={`ri-star-fill text-xs ${i < review.rating ? 'text-accent-500' : 'text-background-300'}`}
                      ></i>
                    ))}
                  </div>
                  <p className="text-sm text-foreground-600 leading-relaxed mb-3">{review.text}</p>
                  <p className="text-xs text-foreground-500">— {review.name}</p>
                </div>
              ))}
            </div>
          </section>

          <section className="mb-12">
            <h2 className="text-xl font-heading font-bold text-foreground-900 mb-4">联系我们</h2>
            <div className="bg-background-100 rounded-lg p-6 md:p-8">
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
                <div>
                  <h3 className="text-base font-medium text-foreground-800 mb-3">联系方式</h3>
                  <ul className="space-y-2.5">
                    <li className="flex items-center gap-2 text-sm text-foreground-600">
                      <span className="w-8 h-8 flex items-center justify-center rounded-full bg-primary-100 text-primary-500 flex-shrink-0">
                        <i className="ri-mail-line"></i>
                      </span>
                      contact@danmeimh.com
                    </li>
                    <li className="flex items-center gap-2 text-sm text-foreground-600">
                      <span className="w-8 h-8 flex items-center justify-center rounded-full bg-primary-100 text-primary-500 flex-shrink-0">
                        <i className="ri-wechat-line"></i>
                      </span>
                      微信公众号：耽美漫画网
                    </li>
                    <li className="flex items-center gap-2 text-sm text-foreground-600">
                      <span className="w-8 h-8 flex items-center justify-center rounded-full bg-primary-100 text-primary-500 flex-shrink-0">
                        <i className="ri-weibo-line"></i>
                      </span>
                      微博：@耽美漫画网官方
                    </li>
                  </ul>
                </div>
                <div>
                  <h3 className="text-base font-medium text-foreground-800 mb-3">商务合作</h3>
                  <ul className="space-y-2.5">
                    <li className="flex items-center gap-2 text-sm text-foreground-600">
                      <span className="w-8 h-8 flex items-center justify-center rounded-full bg-accent-100 text-accent-600 flex-shrink-0">
                        <i className="ri-briefcase-line"></i>
                      </span>
                      商务邮箱：biz@danmeimh.com
                    </li>
                    <li className="flex items-center gap-2 text-sm text-foreground-600">
                      <span className="w-8 h-8 flex items-center justify-center rounded-full bg-accent-100 text-accent-600 flex-shrink-0">
                        <i className="ri-quill-pen-line"></i>
                      </span>
                      漫画投稿：submit@danmeimh.com
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-heading font-bold text-foreground-900 mb-4">版权声明</h2>
            <div className="bg-background-100 rounded-lg p-6">
              <p className="text-sm text-foreground-600 leading-relaxed">
                耽美漫画网上的所有漫画内容均来自网络公开资源与作者授权，仅供学习交流使用。我们尊重每一位创作者的版权，如涉及侵权，请通过上述联系方式通知我们，我们将在第一时间处理。同时，我们鼓励读者在能力范围内支持正版，购买正版漫画是对创作者最好的支持。
              </p>
            </div>
          </section>
        </div>
      </main>
      <Footer />
    </>
  );
}